import { connect } from 'react-redux'
import FileInput from './FileInput'
import { uploadFile, uploadAudio } from '../Files.actions'

const mapStateToProps = ({ files }, { input }) => {
  const file = files[input.name] || {}
  return {
    loading: file.loading || false,
  }
}

const dispatchToProps = {
  uploadFile,
  uploadAudio,
}

export default connect(mapStateToProps, dispatchToProps)(FileInput)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Files/FileInput/FileInput.container.js